import { fragment, icon, node, text } from "~/util/dom";
import { _ } from "~/route/globals";
import createSDSIcon from "~/ui/icon";
import PopOver from "~/ui/popover";
import { ICON_TYPE, ICON_PARAMS } from "~/route4/icons";
import { ROUTE_CONST } from "~/route4/const";

interface IListItem {
	title: string;
	icon: string;
	checked: boolean;
	param: string;
}
export let TYPE: Array<IListItem> = [];
export let OPTIONS: Array<IListItem> = [];

function init() {
	TYPE = [
		{
			title: _("timeboard.names.bus"),
			icon: "bus",
			checked: true,
			param: "bus",
		},
		{
			title: _("timeboard.names.train"),
			icon: "train",
			checked: true,
			param: "train",
		},
		{
			title: _("timeboard.names.tram"),
			icon: "tram",
			checked: true,
			param: "tram",
		},
		{
			title: _("timeboard.names.troley"),
			icon: "trolley",
			checked: true,
			param: "trolley",
		},
		{
			title: _("timeboard.names.metro"),
			icon: "metro",
			checked: true,
			param: "metro",
		},
		{
			title: _("timeboard.names.ferryBoat"),
			icon: "ferryBoat",
			checked: true,
			param: "ferry",
		},
		{
			title: _("timeboard.names.cableWay"),
			icon: "cableWay",
			checked: true,
			param: "cable",
		},
	];

	OPTIONS = [
		{
			title: _("route4.pubt.params.withoutTransfer"),
			icon: "withoutTransfer",
			checked: false,
			param: "tcount",
		},
		{
			title: _("route4.pubt.params.barrierFree"),
			icon: "barrierFree",
			checked: false,
			param: "lowfloor",
		},
		{
			title: _("route4.pubt.params.withABicycle"),
			icon: "bicycle",
			checked: false,
			param: "bike",
		},
		{
			title: _("route4.pubt.params.withAStroller"),
			icon: "stroller",
			checked: false,
			param: "stroller",
		},
		{
			title: _("route4.pubt.params.withAirConditioning"),
			icon: "airConditioning",
			checked: false,
			param: "aircondition",
		},
	];
}


function createListItem(item: IListItem, iconList = ICON_TYPE): {
	container: HTMLParagraphElement;
	toggle: HTMLMapyToggleElement;
} {
	const container = node("p", { className: item.param });
	const toggle = node("mapy-toggle", { checked: item.checked });

	container.append(createSDSIcon({
		symbol: iconList[item.icon],
	}),
	node("span", {}, _(`${item.title}`)),
	toggle);

	return {
		container,
		toggle,
	};
}

export default class ParamsItemPUBTPreferences {
	#label: HTMLDivElement;

	#popup: PopOver;

	#openState: boolean;

	#toggleButton: HTMLButtonElement;

	#iconClosed: SVGSVGElement | HTMLSpanElement;

	#iconOpen: SVGSVGElement | HTMLSpanElement;

	#content: HTMLDivElement;

	#resetButton: HTMLButtonElement;

	#number: HTMLSpanElement;

	#typeItems: Array<HTMLMapyMapToggleElement>;

	#optionsItems: Array<HTMLMapyMapToggleElement>;

	#state: {
		[key: string]: number;
	};

	#callBack: () => void;

	constructor(callBack: () => void) {
		init();

		this.#openState = false;
		this.#callBack = callBack;
		this.#state = {};

		this.#label = node("div", { className: "params-select-label" });
		this.#toggleButton = node("button");
		this.#iconClosed = icon("forward");
		this.#iconOpen = icon("dropdown");
		this.#content = node("div");
		this.#number = node("span", { className: "number" });
		this.#typeItems = [];
		this.#optionsItems = [];

		this.#toggleButton.appendChild(this.#iconClosed);
		this.#label.appendChild(this.#toggleButton);
		this.#label.appendChild(text(_("options")));
		this.#resetButton = node("button", { type: "button", className: "btn-reset hide" }, _("route4.pubt.params.reset"));
		this.#content.appendChild(this.#build());

		this.state = JSON.parse(JSON.stringify(ROUTE_CONST.types.pubt.defaultParams));

		this.#popup = new PopOver({
			anchor: this.#label,
			content: this.#content,
			className: "params-select-popup preferences",
			width: 444,
			onClose: () => {
				this.#close();
			},
			offset: 8,
		});

		this.#resetButton.addEventListener("click", this, false);

		this.#label.addEventListener("click", this, false);
	}

	destroy() {
		this.#toggleButton.removeEventListener("click", this, false);
		this.#close();
	}

	get label() {
		return this.#label;
	}

	set state(val: {
		[key: string]: number;
	}) {
		TYPE.forEach((item, index) => {
			if (item.param in val) {
				this.#typeItems[index].checked = !!val[item.param];
			}
		});

		OPTIONS.forEach((item, index) => {
			if (item.param in val) {
				this.#optionsItems[index].checked = !!val[item.param];
			}
		});

		const valKeys = Object.keys(val);

		if (valKeys.length) {
			const validKeys = valKeys.filter(key => TYPE.findIndex(type => type.param === key) + OPTIONS.findIndex(type => type.param === key) > -2);

			validKeys.forEach(key => {
				this.#state[key] = val[key];
			});
		}

		this.#change();
	}

	get state() {
		return this.#state;
	}

	handleEvent(event: Event) {
		const target = event.target as Node;

		if (this.#label.contains(target) || this.#label === target) {
			if (this.#openState) {
				this.#popup.close();
			} else {
				this.#open();
			}
		} else if (this.#resetButton.contains(target) || this.#resetButton === target) {
			delete this.#state.tcount;
			this.state = JSON.parse(JSON.stringify(ROUTE_CONST.types.pubt.defaultParams));
		}
	}


	#close() {
		this.#iconOpen.remove();
		this.#toggleButton.insertBefore(this.#iconClosed, this.#toggleButton.firstChild);

		this.#label.classList.remove("open");

		this.#openState = false;

		setTimeout(() => {
			this.#callBack();
		}, 300);
	}

	#open() {
		this.#iconClosed.remove();
		this.#toggleButton.insertBefore(this.#iconOpen, this.#toggleButton.firstChild);

		this.#popup.open();

		this.#label.classList.add("open");

		this.#openState = true;
	}

	#build() {
		const frag = fragment();
		const type = node("div", { className: "pubt-type" });
		const typeTitle = node("h4", {}, _("route4.pubt.params.type"));
		const typeList = node("div", { className: "list" });
		const options = node("div", { className: "pubt-options" });
		const optionsTitle = node("h4", {}, _("route4.pubt.params.options"));
		const optionsList = node("div", { className: "list" });
		const doneBtn = node("mapy-router-button", {}, _("done"));
		const bottomButtons = node("div", { className: "bottom-buttons" });

		TYPE.forEach(item => {
			const itemElements = createListItem(item);

			this.#typeItems.push(itemElements.toggle);

			itemElements.container.addEventListener("click", event => {
				if (event.target !== itemElements.toggle) {
					itemElements.toggle.checked = !itemElements.toggle.checked;
					this.#change();
				}
			});
			itemElements.toggle.addEventListener("change", () => {
				this.#change();
			});

			typeList.append(itemElements.container);
		});

		type.append(typeTitle, typeList);

		OPTIONS.forEach(item => {
			const itemElements = createListItem(item, ICON_PARAMS);

			this.#optionsItems.push(itemElements.toggle);

			itemElements.container.addEventListener("click", event => {
				if (event.target !== itemElements.toggle) {
					itemElements.toggle.checked = !itemElements.toggle.checked;
					this.#change();
				}
			});
			itemElements.toggle.addEventListener("change", () => {
				this.#change();
			});

			optionsList.append(itemElements.container);
		});

		options.append(optionsTitle, optionsList);

		doneBtn.addEventListener("click", () => {
			this.#popup.close();
		});

		bottomButtons.append(doneBtn, this.#resetButton);

		options.appendChild(bottomButtons);

		frag.append(type, options);

		return frag;
	}

	#change() {
		const uncheckedType = this.#typeItems.filter(toggle => !toggle.checked);
		let number = 0;

		if (uncheckedType.length) {
			number = this.#typeItems.length - uncheckedType.length;
		}

		this.#optionsItems.forEach(toggle => {
			if (toggle.checked) {
				number++;
			}
		});

		if (number) {
			this.#number.textContent = number.toString();
			this.#label.appendChild(this.#number);
			this.#resetButton.classList.remove("hide");
		} else {
			this.#number.remove();
			this.#resetButton.classList.add("hide");
		}

		this.#typeItems.forEach((item, key) => {
			this.#state[TYPE[key].param] = item.checked ? 1 : 0;
		});

		this.#optionsItems.forEach((item, key) => {
			this.#state[OPTIONS[key].param] = item.checked ? 1 : 0;
		});
	}
}
